import type { ICategoryItem } from "app/components/React/CategoriesDropdown/CategoryDropdown";

import { formatVisits } from "../../helpers";
import type { SiteVisitsOvertime } from "../hooks/useVisitsOvertimeData";
import type { ProcessedData } from "../types";

interface LobCategoryItem extends ICategoryItem {
    visitsText: string;
    onClick?: () => void;
}
export const createLobCategories = (
    availableLobs: string[],
    lobVisitsData?: Record<string, number>,
): LobCategoryItem[] => {
    return availableLobs.map((lob) => {
        const visits = lobVisitsData?.[lob] || 0;
        const visitsText = visits > 0 ? formatVisits(visits) : "";

        return {
            id: lob,
            text: lob,
            visitsText,
            isCustomCategory: false,
        };
    });
};

export const processCompareModeData = (data: Record<string, SiteVisitsOvertime>, selectedLob?: string) => {
    if (!data) {
        return { processedData: null, availableLobs: [], lobVisitsData: {} };
    }

    const lobVisitsMap: Record<string, number> = {};
    Object.values(data).forEach((siteData) => {
        if (siteData?.TotalLobsVisits) {
            Object.entries(siteData.TotalLobsVisits).forEach(([lobName, lobData]: [string, any]) => {
                if (lobData.Visits > 0) {
                    lobVisitsMap[lobName] = (lobVisitsMap[lobName] || 0) + lobData.Visits;
                }
            });
        }
    });

    const availableLobs = Object.entries(lobVisitsMap)
        .sort(([, a], [, b]) => b - a)
        .map(([name]) => name);

    const lob = selectedLob && availableLobs.includes(selectedLob) ? selectedLob : availableLobs[0];

    const total: Record<string, { Visits: number; Share: number }> = {};
    const breakdown: Record<string, Record<string, { Visits: number }>> = {};
    const siteVisits: Record<string, number> = {};

    Object.entries(data).forEach(([domain, siteData]: [string, SiteVisitsOvertime]) => {
        if (siteData?.TotalLobsVisits?.[lob]) {
            total[domain] = siteData.TotalLobsVisits[lob];

            Object.entries(siteData.SiteVisits).forEach(([date, visits]) => {
                if (!siteVisits[date]) {
                    siteVisits[date] = 0;
                }
                siteVisits[date] += visits;
            });

            Object.entries(siteData.LobsMonthlyBreakDown || {}).forEach(([date, monthData]: [string, any]) => {
                if (!breakdown[date]) {
                    breakdown[date] = {};
                }
                if (monthData[lob]) {
                    breakdown[date][domain] = monthData[lob];
                }
            });
        }
    });

    const processedData: ProcessedData = {
        total,
        breakdown,
        siteVisits,
    };

    return {
        processedData,
        availableLobs,
        lobVisitsData: lobVisitsMap,
    };
};
